import React, { Component } from 'react';
import AdminSummaryView from './AdminSummaryView';
import moment from 'moment'
import { url } from '../../../Server/url/GlobalUrl';

class AdminSummaryComponent extends Component {
    state = {
        perssonal_detail : '',
        file_name : '',
        title_type : '',
        right_to_work_selected : '',
        formated_date : '',
        user_verification_status: [],
        authResponse:'',
		modal_show: false,
        user_verification_description:'',
        user_verification_id:'',
        admin_notice:'',
        user_email:'',
        post_description:'',
        professional_profile : [],
        Availablity : [],

    }

    hideCustomModal = () => {
        this.setState({ modal_show: false })
    }

    showCustomModal = () => {
        this.setState({ modal_show: true })
    }

    handelData  = (data) =>{
          this.setState({user_verification_id: data})
          fetch((url + "/api/v1/user/user-verification-status/"+data+"/"), {
                method: 'GET',
                 headers: {
                   'Accept': 'application/json',
                  'Content-Type': 'application/json',
                },
                })
              .then((response) => {
                    console.log("response", response)
                    if (response['status'] === 201 || response['status'] === 200) {
                        console.log('200')
                        return response.json()
                    } else if (response['status'] === 400) {
                        console.log('400')
                        return response.json()
                    }
                })
              .then(
		        (result) => {
		            console.log('user-verification-status',result)
		            this.setState({user_verification_description: result.description})
		            this.setState({post_description: result.description})
		        })
    }

    handeltext  = (data) =>{
        console.log('data',data)
        this.setState({'user_verification_description':data})
    }

    handelsubmit  = () =>{

        if (this.state.user_verification_id !== ""){
                console.log('inside the handelsubmit')
                let form_data = new FormData();
                form_data.append('email', this.state.user_email);
                form_data.append('verification_status', this.state.user_verification_id);
                form_data.append('admin_notice', this.state.user_verification_description);
                fetch((url + "/api/v1/user/user-verification-status/"+ this.state.user_verification_id + '/'), {
                        method: 'GET'
                        })
                      .then(res => res.json())
                      .then(
                        (result) => {
                          console.log('result.type',result.type)
                          if (result.type === 'Schedule Interview'){
                            form_data.append('is_candidate', true);
                          }
                          else{
                            form_data.append('is_candidate', false);
                          }
                          fetch(url + '/api/v1/user/submit-details/' + localStorage.getItem('cv-id') + '/', {
                method: 'PUT',
                body: form_data
                })
                .then((response) => {
                    console.log("response", response)
                    if (response['status'] === 201 || response['status'] === 200) {
                        console.log('200')
                        this.showCustomModal()
				        this.setState({authResponse:'Candidate verified successfully'})
                        return response.json()
                    } else if (response['status'] === 400) {
                        this.showCustomModal()
				        this.setState({authResponse:'Something Went Wrong Please try again'})
                    }
                })
                .then((result) => {console.log('result',result)
                })
                .catch(error => {
                    console.log(error)
                });
                        },
                        (error) => {
                          console.log('error',error)
                        })

        }
        else{
            alert('please select the option')
        }

    }

    componentDidMount() {
        console.log('cv-id',localStorage.getItem('cv-id'))
         let id = localStorage.getItem('cv-id')
		fetch((url + "/api/v1/user/submit-details/"+id+'/'), {
                method: 'GET',
                 headers: {
                   'Accept': 'application/json',
                  'Content-Type': 'application/json',
                },
                })
              .then(res => res.json())
              .then(
		        (result) => {
		          console.log('resukt',result)
		          this.setState({user_email: result.email})
		          this.setState({completion_year: result.completion_year})
		          this.setState({Organization: result.Organization})
		          this.setState({experience_last_worked_date: result.experience_last_worked_date})
		          this.setState({licence_number: result.licence_number})
		          this.setState({school_name: result.school_name})
		          this.setState({ni_number: result.ni_number})
		          this.setState({nationality: result.licence_is_nationality_uk})
		          this.setState({care_type: result.care_type})
		          this.setState({passport_number: result.passport_number})
		          this.setState({experience_last_worked_date: result.experience_last_worked_date})
		          this.setState({perssonal_detail: result})
		          if (result.filepath){
		          var day = moment(result.date_of_birth).format("MMMM DD, YYYY")
		          this.setState({formated_date: day})
		          console.log('day',day)
		          const uri = result.filepath.split("/").pop()
		          this.setState({file_name: uri})
		          }
		          fetch((url + "/api/v1/user/educational-qualification/" + result.educational_qualification + '/'), {
                        method: 'GET'
                        })
                      .then(res => res.json())
                      .then(
                        (result) => {
                          this.setState({educational_qualification: result.type})
                          console.log('result',result)
                        },
                        (error) => {
                          console.log('error',error)
                        })
                  fetch((url + "/api/v1/user/professional-profile/?user=" + localStorage.getItem('cv-id')), {
                        method: 'GET'
                        })
                      .then(res => res.json())
                      .then(
                        (result) => {
                          this.setState({professional_profile : result})
                          console.log('result',result)
                        },
                        (error) => {
                          console.log('error',error)
                        })

                  fetch((url + "/api/v1/user/availablity/?user=" + localStorage.getItem('cv-id')), {
                        method: 'GET'
                        })
                      .then(res => res.json())
                      .then(
                        (result) => {
                          this.setState({Availablity : result})
                          console.log('result',result)
                        },
                        (error) => {
                          console.log('error',error)
                        })
		          fetch((url + "/api/v1/user/title/" + result.title + '/'), {
                        method: 'GET'
                        })
                      .then(res => res.json())
                      .then(
                        (result) => {
                          this.setState({title_type: result.type})
                          console.log('result',result)
                        },
                        (error) => {
                          console.log('error',error)
                        })
                fetch((url + "/api/v1/user/right-to-work/"+result.right_to_work+'/'), {
                        method: 'GET'
                        })
                      .then(res => res.json())
                      .then(
                        (result) => {
                          this.setState({right_to_work_selected: result.type})
                          console.log('result',result)
                        },
                        (error) => {
                          console.log('error',error)
                        })
		        },
		        (error) => {
		          console.log('error',error)
				})
				fetch((url + "/api/v1/user/user-verification-status/"), {
                        method: 'GET'
                        })
                      .then(res => res.json())
                      .then(
                        (result) => {
                          this.setState({user_verification_status: result})
                          console.log('result',result)
                        },
                        (error) => {
                          console.log('error',error)
                        })


    }

 render() {
        return (
            <AdminSummaryView
                handelsubmit = {this.handelsubmit}
                handelData = {this.handelData}
                handeltext = {this.handeltext}
                perssonal_detail={this.state.perssonal_detail}
                file_name={this.state.file_name}
                title_type={this.state.title_type}
                right_to_work_selected={this.state.right_to_work_selected}
                formated_date={this.state.formated_date}
                user_verification_status={this.state.user_verification_status}
                user_verification_description={this.state.user_verification_description}
                authResponse = {this.state.authResponse}
				modal_show = {this.state.modal_show}
				hideCustomModal = {this.hideCustomModal}
				Organization = {this.state.Organization}
				experience_last_worked_date = {this.state.experience_last_worked_date}
				passport_number = {this.state.passport_number}
				ni_number = {this.state.ni_number}
				licence_number = {this.state.licence_number}
				school_name = {this.state.school_name}
				completion_year = {this.state.completion_year}
				care_type = {this.state.care_type}
				nationality = {this.state.nationality}
				educational_qualification = {this.state.educational_qualification}
				professional_profile = {this.state.professional_profile}
				Availablity = {this.state.Availablity}
            />
        )
    }

}

export default AdminSummaryComponent;